var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "United_kingdom",
    className: "england",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 256,
    cy: 256,
    r: 254
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "blue_background",
    x: -258.325,
    clipPath: "url(#SVGID_2_)",
    fill: "#337EBE",
    width: 1027.65,
    height: 513.827
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "blue_background_1_",
    x: -258.325,
    width: 1027.65,
    height: 513.827
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blue_background_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blue_background_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -319.803,
    y: 209.047,
    transform: "matrix(-0.8944 -0.4472 0.4472 -0.8944 380.874 610.7694)",
    clipPath: "url(#blue_background_2_)",
    fill: "#FFFFFF",
    width: 1164.664,
    height: 102.762
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    points: "-258.325,0 262.528,260.428 247.213,291.067  -273.643,30.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    points: "277.851,229.788 798.7,490.218 783.379,520.853  262.528,260.428  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -319.806,
    y: 202.014,
    transform: "matrix(-0.8944 0.4472 -0.4472 -0.8944 610.6595 362.6334)",
    clipPath: "url(#blue_background_2_)",
    fill: "#FFFFFF",
    width: 1164.666,
    height: 102.762
  }), /*#__PURE__*/React.createElement("rect", {
    x: -281.404,
    y: 381.804,
    transform: "matrix(-0.8944 0.4472 -0.4472 -0.8944 196.9041 751.3832)",
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    width: 582.333,
    height: 34.258
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    points: "247.213,222.758 768.062,-37.669 783.379,-7.031  262.528,253.398  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.862,
    clipPath: "url(#blue_background_2_)",
    fill: "#FFFFFF",
    width: 171.273,
    height: 513.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: -258.325,
    y: 171.274,
    clipPath: "url(#blue_background_2_)",
    fill: "#FFFFFF",
    width: 1027.65,
    height: 171.272
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.114,
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    width: 102.769,
    height: 513.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: -258.325,
    y: 205.529,
    clipPath: "url(#blue_background_2_)",
    fill: "#C7463D",
    width: 1027.65,
    height: 102.767
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingdom);
export default __webpack_public_path__ + "static/media/kingdom.6e377d959886d0c91dbe45b1b6ec2957.svg";
export { ForwardRef as ReactComponent };